import halicLogo from "@/assets/img/halic/logo-halic.png";
import cinarLogo from "@/assets/img/cinar/logo-cinar.png";
import uyumLogo from "@/assets/img/uyum_logo.png";

type Brand = "halic" | "cinar" | "uyum";

type BrandMetadata = {
  brand: Brand;
  logo: string;
  companyName: string;
  favicon: string;
};

const envBrand = (import.meta.env.VITE_BRAND ?? "").trim().toLowerCase();
const defaultCompanyName = import.meta.env.VITE_COMPANY_NAME ?? "Uyumsoft Kurumsal Is Sistemleri Odeme Platformu";
const defaultFavicon = (import.meta.env.VITE_FAVICON ?? "/favicon.svg").trim();

const brandMetadata: Record<Brand, BrandMetadata> = {
  halic: {
    brand: "halic",
    logo: halicLogo,
    companyName: import.meta.env.VITE_HALIC_COMPANY_NAME ?? "Halic Universitesi Odeme Platformu",
    favicon: import.meta.env.VITE_HALIC_FAVICON ?? "/favicon-halic.png",
  },
  cinar: {
    brand: "cinar",
    logo: cinarLogo,
    companyName: import.meta.env.VITE_CINAR_COMPANY_NAME ?? "Cinar Koleji Odeme Platformu",
    favicon: import.meta.env.VITE_CINAR_FAVICON ?? "/favicon-cinar.png",
  },
  uyum: {
    brand: "uyum",
    logo: uyumLogo,
    companyName: defaultCompanyName,
    favicon: defaultFavicon,
  },
};

const getCurrentHost = (): string => {
  if (typeof window === "undefined") return "";
  return window.location.host.toLowerCase();
};

const getBrandFromHost = (): Brand | undefined => {
  const host = getCurrentHost();
  if (!host || host.includes("localhost")) return undefined;
  if (host.includes("halicpayment") || host.includes("halic")) return "halic";
  if (host.includes("cinarkoleji") || host.includes("cinar")) return "cinar";
  if (host.includes("uyumsoft")) return "uyum";
  return undefined;
};

const getBrandFromEnv = (): Brand | undefined => {
  if (envBrand === "halic" || envBrand === "cinar" || envBrand === "uyum") return envBrand;
  return undefined;
};

export function getBrandMetadata(): BrandMetadata {
  const configuredBrand = getBrandFromEnv();
  const brand = configuredBrand ?? getBrandFromHost() ?? "uyum";

  if (brand === "halic" && getCurrentHost().includes("yurtodeme.halic.edu.tr")) {
    return {
      ...brandMetadata.halic,
      companyName: import.meta.env.VITE_HALIC_YURT_COMPANY_NAME ?? brandMetadata.halic.companyName,
    };
  }

  if (!configuredBrand) return brandMetadata[brand];

  const metadata = brandMetadata[brand];
  return {
    ...metadata,
    companyName: defaultCompanyName,
    favicon: defaultFavicon || metadata.favicon,
  };
}

export function getBrandLogo(): string {
  return getBrandMetadata().logo;
}
